import * as Styled from "./Styled";
import Sidemenu from "../../components/sidemenu";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { functionService } from "../../lib/functions";
import Dropdown from 'react-bootstrap/Dropdown';
import styles from './styles/style.module.css'

const CoffeeePlus = () => {
    const navigate = useNavigate();
    const [funnels, setFunnels] = useState([]);
    const [funnelLoader, setFunnelLoader] = useState(true);
    const [error, setError] = useState(null);
    const [searchedFunnel, setSearchedFunnel] = useState("");

    const CoffeePlusSkillFilter = () => {
        const [skills, setSkills] = useState([]);
        const getSkills = async () => {
            try {
                let { response } = await functionService.get('coffeeePlus/skills');
                if (response.status === 200) {
                    setSkills(response?.data?.data?.skills);
                } else {
                    console.log("error fetching skills");
                } 
            } catch (e) {
                console.log(e);
            }
        }

        const filterFunnelsOnSkills = async (e) => {
            try {
                let val = e.target.innerText;
                if (val === "None") {
                    val = "";
                }
                let { response } = await functionService.get(`coffeeePlus/filter?skill=${val}`);
                if (response.status === 200) {
                    setFunnels(response?.data?.data?.funnels);
                } else {
                    console.log("error occured while filtering")
                }

            } catch (e) {
                console.log(e);
            }
        } 

        useEffect(() => {
            getSkills();    
        }, [])
    
        return (
            <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic" style={{color: "#939599", background: "#fff", fontSize: "14px", lineHeight: "18px", fontWeight: "400", border: "1px solid #c9c9c9", height: "40px", width:"115px"}}>
                    Select Skills
                </Dropdown.Toggle>
        
                <Dropdown.Menu style={{height: "200px", overflow: "scroll", width:"115px"}}>
                    <Dropdown.Item onClick={(e) => filterFunnelsOnSkills(e)} style={{width:"115px"}}>None</Dropdown.Item>
                    {
                        skills?.map((s) => (
                            <Dropdown.Item style={{width:"115px"}} onClick={(e) => filterFunnelsOnSkills(e)}>{s.name}</Dropdown.Item>
                        ))
                    }
                </Dropdown.Menu>
          </Dropdown>
        )
    }

    const CoffeePlusSortFilter = () => {
        const filters = ["StartDate", "EndDate", "Name", "Contest Plus", "Coffeee Plus"];

        const sortFunnels = async (e) => {
            try {
                let val = e.target.innerText;
                if (val === "None") {
                    val = "";
                }
                let { response } = await functionService.get(`coffeeePlus/sort?order=${val}`);
                if (response.status === 200) {
                    setFunnels(response?.data?.data?.funnels);
                } else {
                    console.log("error while sorting funnels");
                }
            } catch (e) {
                console.log(e);
            }
        }                

        return (
            <Dropdown style={{marginLeft: "20px"}}>
                <Dropdown.Toggle variant="success" id="dropdown-basic" style={{color: "#939599", background: "#fff", fontSize: "14px", lineHeight: "18px", fontWeight: "400", border: "1px solid #c9c9c9", height: "40px", width:"115px"}}>
                    Sort By
                </Dropdown.Toggle>
                <Dropdown.Menu style={{width:"115px"}}>
                    <Dropdown.Item onClick={(e) => sortFunnels(e)} style={{width:"100%"}}>None</Dropdown.Item>
                    {
                        filters?.map((f) => (
                            <Dropdown.Item onClick={(e) => sortFunnels(e)} style={{width:"100%"}}>{f}</Dropdown.Item>
                        ))
                    }
                </Dropdown.Menu>
          </Dropdown>
        )
    }
    
    const getFunnelList = async () => {
        try {
            setFunnelLoader(true);
            let { response } = await functionService.get(`coffeeePlus/all-funnels`);
            if (response.status === 200) {
                setFunnels(response?.data?.data?.allFunnels);
                console.log(response);
            } else {
                setError("Error fetching funnels");
            }
            setFunnelLoader(false);
        } catch (e) {
            console.log(e);
            setError("Error Fetching Funnels");
        }
    }

    const handleDelete = async (funnelId) => {    
        try {   
            let { response } = await functionService.remove(`coffeeePlus/funnel/${funnelId}`);
            if (response.status === 200) {
                console.log("Deleted successfully")
            } else {
                console.log("error while deleting")
            }
            getFunnelList();
        } catch (e) {
            console.log(e);
        }
    }

    const handleEdit = (funnelId) => {
        navigate(`/coffeee-plus/edit/${funnelId}`);
    }

    const searchFunnels = async (funnelName) => {
        setSearchedFunnel(funnelName);
        try {
            let { response } = await functionService.get(`coffeeePlus/all-funnels?funnelName=${funnelName}`);
            if (response.status === 200) {
                setFunnels(response?.data?.data?.allFunnels);
            } else {
                console.log("error searching funnels")
            }
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        getFunnelList();
    }, [])

    return (
    <Styled.MainDiv>
      <Sidemenu />
      <Styled.ColumnDiv>
        <div style={{height:"100vh", overflow:"scroll"}}>
            <div className={styles.funnelHeaderWrap}>
                <div>
                    <h1 style={{fontSize: "30px", lineHeight: "35px", fontWeight:"700"}}>Coffeee+</h1>
                    <h3 style={{fontSize: "16px", lineHeight: "19px", fontWeight:"400"}}>Create, edit and manage all the articles</h3>
                </div>
                <div>
                    <label>
                        <input style={{width: "350px", color: "#000000", background: "#fff", fontSize: "14px", lineHeight: "18px", fontWeight: "400", border: "1px solid #c9c9c9", height: "40px"}} value={searchedFunnel} type="text" onChange={(e) => {searchFunnels(e.target.value)}} placeholder="Search for funnels" />
                    </label>
                </div>
                <div className={styles.filterWrap}>
                    <CoffeePlusSkillFilter />
                    <CoffeePlusSortFilter />
                    <div style={{marginLeft:"15px"}}>
                        <button onClick={() => navigate('/coffeee-plus/new')} className={styles.addFunnelBtn}>+ Coffeee+ Level</button>
                    </div>
                </div>
            </div>
            <div>
            {
                funnels?.map ((f) => (
                    <div className={styles.funnels}> 
                        <div className={styles.funnelContent}>
                            {
                                (f.funnel_image !== '' && f.funnel_image) ? 
                                    <div style={{maxWidth:"273px", marginRight: "20px", width: "100%"}}>
                                        <img style={{width:"100%", maxWidth:"100%", height:"132px", display:"block", margin: "0 auto"}} src={f.funnel_image} alt="funnel_image" />
                                    </div>
                                : ''
                            }
                            <p style={{margin: "0px", fontSize:"16px", lineHeight:"19px", fontWeight:"700"}}>{f.funnel_title}</p>
                        </div>
                        <div style={{maxWidth: "60px", display:"flex", alignItems: "center", justifyContent: "space-between", width:"100%"}}>
                            <button onClick={(e) => handleEdit(f.id)} className={styles.editBtn}></button>
                            <button onClick={(e) => handleDelete(f.id)} className={styles.deleteBtn}></button>
                        </div>
                    </div>
                ))                  
            }
            </div>
        </div>
      </Styled.ColumnDiv>
    </Styled.MainDiv>
    );
  };
  
  export default CoffeeePlus;